import { render, staticRenderFns } from "./BookingOldInfo.vue?vue&type=template&id=1a5c2e60&scoped=true&"
import script from "./BookingOldInfo.vue?vue&type=script&lang=js&"
export * from "./BookingOldInfo.vue?vue&type=script&lang=js&"
import style0 from "./BookingOldInfo.vue?vue&type=style&index=0&id=1a5c2e60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5c2e60",
  null
  
)

export default component.exports